module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('gheader', {
    attrs: {
      "type": "home"
    }
  }), _vm._v(" "), _c('glogo'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-agreement"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    attrs: {
      "id": "agreement"
    }
  }, [_c('h2', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("供应商操作手册")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "source"
    }
  }, [_c('p')]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('h3', [_vm._v("一、供应商须知")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("尊敬的供应商：")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("您好！")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("目前友云采已经上线了网上招标采购系统，未来我们会招标的很多流程都会放在网上，期待您注册网上招采平台跟友云采长期合作。")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("为了帮助您更好的了解和掌握此系统，我们编写的以下操作手册，希望能够帮到您。以后如果在使用过程中遇到问题，一定要记得及时联系我们哦。")]), _vm._v(" "), _c('h3', [_vm._v("二、供应商注册申请流程-企业用户注册")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_0.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("1.网上招采地址")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("请在浏览器中输入地址https://yc.yonyoucloud.com/smisupply/home.html登陆城投水务供应商资料信息完善门户。")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("2.供应商注册")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("希望参加友云采采购招标的供应商需要在网上申请成为友云采的供应商。")]), _vm._v(" "), _c('h5', [_vm._v("2.1 开始注册")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("点击“供应商注册”按钮开始注册。")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_1.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("2.2 确认相关条款")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("同意并继续后开始填写相关资料")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual_2.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("2.3 填写账号信息")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("手机号：需要用手机号进行注册（一个手机号只能注册一个账号）")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("账号：即登录友云采进行报名，投标等操作的账号（账号必须是唯一的无法重复）")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("密码：账户的密码")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("企业名称：请确认是公司全称，注册后无法修改。")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("相关信息填写完整后点击“下一步，完善供应商信息”系统会提示“您的账号已经注册成功”")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual4.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("2.4 回到首页")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("点击“供应商资料信息完善” -进入登录页面 - 点击“忘记密码”")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual5.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual6.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("2.5 找回密码")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("重新设定密码")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual7.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("2.6 供应商资料信息完善")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("点击“登录”")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual8.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual9.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("3.完善资质信息")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("3.1 完善供应商资质信息")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("供应商名称：由上一步代入")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("管理组织：即确定您提交的资料由哪一家公司审核，选择分公司对应的本部，比如“供水公司本部” 。")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("供应商资质信息：请选择是上传三证还是五证，并需要填写相关证件号。供应商还可以新增资质证件。")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("供应品类：即您要申请的供货类别，请选择到最末级（请如实填写），"), _c('span', {
    staticClass: "redFont"
  }, [_vm._v("所有上传的附件以及证件都需要提交资料须企业法人代表签字并加盖单位公章；国外供应商应提供相应的资料，外文版资料应提供相应中文翻译件")])]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("继续完善资料")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("相关资料填写完成后点击“提交采购商审核即可”")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual10.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual11.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual12.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual13.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("(1).如果资质证件到期日为无限定日期，则在发证日期+50年，比如发证日期2003年10月9日，则到期日为2053年10月9日。")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("(2).供应商资质信息点击“添加资质”即跳出资质选择弹窗，可以通过快速搜索进行查找，然后勾选，另外也可以通过点击左侧分类查找，选中对应的资质等级")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual14.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("(1).供应品类则选择对应提供的服务，选择最末级的类别，建议主要选择与城投发生业务往来的服务项")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("(2).资质信息全部完善之后，点击“提交审核”即可")]), _vm._v(" "), _c('h4', [_vm._v("4.供应商申请结果查询")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("4.1 查看供应商审核是否通过")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("(1).账号登录")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("供应商登录账号，登录后点击进入工作台。")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual15.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("(2).查看供应商申请界面，点击左侧“客户管理”，点击“我的申请”即可")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual16.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("(3).查看审核是否通过")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("待审核状态可以查看相关供应商资料，申请被驳回后，可以修改相关资料重新提交，申请通过后可以进入云采平台供应商档案。")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual17.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("三、管理组织准入审批操作流程")]), _vm._v(" "), _c('h4', [_vm._v("1.采购方管理组织审核")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("供应商注册提交后，采购方管理组织权限的人员进入工作台后，点击“准入管理”查看待审核供应商详情。")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual18.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("2. 采购方管理组织审核")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("点击“查看详情”，可查看到供应商详情档案，如材料没问题，会判断供应商材料是否为相似供应商，可以点击“合并”，然后点击“准入”")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual19.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual20.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("如果材料有问题，则点击驳回并提交理由，供应商进入工作台在供应商申请单中驳回中，然后重新填写继续提交申请。")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("注：可以通过供应商准入状态上的数量计算完善供应商信息的数量，只需计算待审核+已通过的供应商。，右上角的搜素框支持搜索查询供应商。")]), _vm._v(" "), _c('h4', [_vm._v("3. 供应商档案")]), _vm._v(" "), _c('p', {
    staticClass: "text-padding"
  }, [_vm._v("点击“查看详情”，可查看到供应商详情档案。")]), _vm._v(" "), _c('div', {
    staticClass: "manual-img"
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/manual21.png",
      "alt": ""
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a833078!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/manual/manual.vue
// module id = 220
// module chunks = 4